import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ObservacoesListComponent } from './observacoes-list/observacoes-list.component';
import { ObservacoesFormComponent } from './observacoes-form/observacoes-form.component';
import { ObservacoesModalComponent } from './observacoes-modal/observacoes-modal.component';
@NgModule({
  declarations: [
    ObservacoesListComponent,
    ObservacoesFormComponent,
    ObservacoesModalComponent
  ],
  exports:[
    ObservacoesListComponent,
    ObservacoesFormComponent,
    ObservacoesModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [
    provideNgxMask()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ObservacoesModule { }
